import { lazy } from "react";
import { Navigate } from "react-router-dom";

const Mng001 = lazy(() => import("../pages/mng/mng001/Mng001"));
const Mng002 = lazy(() => import("../pages/mng/mng002/Mng002"));
const Mng003 = lazy(() => import("../pages/mng/mng003/Mng003"));
const Mng004 = lazy(() => import("../pages/mng/mng004/Mng004"));
const Mng00101 = lazy(() => import("../pages/mng/mng001/Mng00101"));
const Mng00102 = lazy(() => import("../pages/mng/mng001/Mng00102"));
const Mng00301 = lazy(() => import("../pages/mng/mng003/Mng00301"));
const Mng00302 = lazy(() => import("../pages/mng/mng003/Mng00302"));
const Mng00201 = lazy(() => import("../pages/mng/mng002/Mng00201"));
const Mng00402 = lazy(() => import("../pages/mng/mng004/Mng00402"));
const Mng00401 = lazy(() => import("../pages/mng/mng004/Mng00401"));
const Mng005 = lazy(() => import("app/pages/mng/mng005/Mng005"));


export const mngRouter: any = [
  // 기업
  { path: "mng", element: <Navigate to="mng001" replace /> },
  { path: "mng/mng001", element: <Mng001 /> },
  { path: "mng/mng001/form", element: <Mng00101/> },
  { path: "mng/mng001/detail", element: <Mng00102/> },
  { path: "mng/mng002", element: <Mng002 /> },
  { path: "mng/mng002/form", element: <Mng00201/> },
  { path: "mng/mng003", element: <Mng003 /> },
  { path: "mng/mng003/form", element: <Mng00301/> },
  { path: "mng/mng003/detail", element: <Mng00302/> },
  { path: "mng/mng004", element: <Mng004 /> },
  { path: "mng/mng004/form", element: <Mng00401/> },
  { path: "mng/mng004/detail", element: <Mng00402/> },
  { path: "list/list012", element: <Mng005 /> },
]